'use client'

import { useMemo, useState } from 'react'
import { calcPlastering } from '@/lib/calculators/formulas'
import { ToolField, ToolResultCard, ToolResultRow, toolCurrency, toolFmt, toolNum } from './tool-inputs'

export function PlasteringCalculatorTool() {
  const [area, setArea] = useState('30')
  const [thickness, setThickness] = useState('15')
  const [bagPrice, setBagPrice] = useState('95')

  const r = useMemo(
    () => calcPlastering(toolNum(area), toolNum(thickness), 0, 40, toolNum(bagPrice), 0),
    [area, thickness, bagPrice],
  )

  return (
    <div className="grid gap-6 md:grid-cols-[1fr_380px] md:items-start">
      <div className="space-y-5 rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Wall / area</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Area to plaster" value={area} onChange={setArea} unit="m²" />
            <ToolField label="Thickness" value={thickness} onChange={setThickness} unit="mm" step="1" hint="12–20 mm typical" />
          </div>
        </div>
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Price</h2>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <ToolField label="Plaster price" value={bagPrice} onChange={setBagPrice} unit="R/bag" hint="40 kg bag" />
          </div>
        </div>
      </div>

      <ToolResultCard title="Your plaster estimate">
        <ToolResultRow label="Area" value={`${toolFmt(toolNum(area), 1)} m²`} />
        <ToolResultRow label="Plaster bags (40 kg)" value={`${r.totalBags} bags`} />
        <ToolResultRow label="Estimated plaster cost" value={toolCurrency(r.materialsCost)} strong />
      </ToolResultCard>
    </div>
  )
}
